import { cols } from "@/config/system";
import { momentFormat, getStoreMapWithDicKey, mapValueFormat } from "@/utils/formatter";
import { getPointerStatusClass } from "@/utils/utilFuns";
import { h } from "vue";

export function getTableColumn(type: string) {
  return [
    {
      label: '电子面单账号',
      prop: 'partnerId',
      width: cols.op4
    },
    {
      label: "面单类型",
      prop: "partnerType",
      width: cols.op3
    },
    {
      label: "操作类型",
      prop: "operationType"
    },
    {
      label: type === '0' ? "订单编号" : "回收单号",
      prop:  type === '0' ? "orderNumber" : 'billCode',
      width: cols.op4
    },
    {
      label: "操作时间",
      prop: "operationTime",
      width: cols.op4,
      formatter: (row: any, column: any, cellValue: string) =>
        momentFormat(cellValue, "YYYY-MM-DD HH:mm:ss")
    },
    {
      label: "状态",
      prop: "status",
      formatter: (row: any, column: any, cellValue: string) => {
        return h('div', {}, [
          h('i', { class: getPointerStatusClass(cellValue), style: { marginRight: '8px' } }),
          h('span', {}, mapValueFormat(cellValue, getStoreMapWithDicKey(type === '0' ? 'partner_recharge_account_status' : 'partner_recycle_account_status')))
        ])
      }
    },
    {
      label: type === '0' ? "充值数量" : "回收数量",
      prop: "num",
    },
    {
      label: "平台",
      prop: "platform",
      width: cols.op3
    },
    {
      label: "网点名称",
      prop: "netName",
      width: cols.op3
    },
    {
      label: "备注",
      prop: "remark",
      width: cols.op4
    },
  ];  
}
